

















import Vue from "vue"
import MaterialIcon, {
  OUTLINED,
  FILLED,
} from "~/components/guideline/icon/MaterialIcon.vue"

export default Vue.extend({
  components: {
    MaterialIcon,
  },
  props: {
    isFavorited: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    iconType() {
      return { OUTLINED, FILLED }
    },
  },
  methods: {
    handleClick(): void {
      this.$emit("click")
    },
  },
})
